import { render, staticRenderFns } from "./promoCard.vue?vue&type=template&id=a97604f6&scoped=true&"
import script from "./promoCard.vue?vue&type=script&lang=js&"
export * from "./promoCard.vue?vue&type=script&lang=js&"
import style0 from "./promoCard.vue?vue&type=style&index=0&id=a97604f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97604f6",
  null
  
)

export default component.exports